/**
 * Application entry point
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { MantineProvider, Tooltip, createTheme } from "@mantine/core";
import "@mantine/core/styles.css";

import { router } from "./router";
import { installGlobalErrorReporting } from "./errorReporting";

// Extend window interface for session ID
declare global {
  interface Window {
    sessionId: string;
  }
}

const theme = createTheme({
  primaryColor: "blue",
  defaultRadius: "sm",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  components: {
    // Mantine only opens tooltips on hover by default, so on a touch device
    // every explanation attached to a tooltip — servo series compatibility,
    // what each header action does — was simply unreachable.
    Tooltip: Tooltip.extend({
      defaultProps: {
        events: { hover: true, focus: true, touch: true },
      },
    }),
  },
});

// Uncaught errors and rejected promises are otherwise only seen by the one
// browser that hit them; the access log gets a CLIENT_ERROR entry instead.
installGlobalErrorReporting();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <RouterProvider router={router} />
    </MantineProvider>
  </React.StrictMode>
);
